// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Messages":"co_a bhc_a bhc_w","Messages__hasSeen":"co_b bhc_p"};